import { marked } from "marked";
import DOMPurify from "dompurify";

marked.setOptions({
  gfm: true,
  breaks: false,
  headerIds: false,
  mangle: false,
});

const SANITIZE_OPTS = { ADD_ATTR: ["target", "rel"] };

function looksLikeHtml(str) {
  if (!str) return false;
  const s = String(str).trim();
  // Any block-level tag = treat as HTML (TipTap always outputs at least <p>)
  return /^<(p|h[1-6]|ul|ol|blockquote|pre|figure|div|img|hr|br)\b/i.test(s);
}

/**
 * Render post body — accepts either HTML (from TipTap) or Markdown (legacy).
 * Sanitizes with DOMPurify in both cases.
 */
export function renderPostBody(body) {
  if (!body) return "";
  const raw = looksLikeHtml(body) ? String(body) : marked.parse(String(body));
  return DOMPurify.sanitize(raw, SANITIZE_OPTS);
}

/**
 * Kept for backward-compat with existing imports.
 */
export function renderMarkdown(body) {
  return renderPostBody(body);
}

/**
 * Strip HTML/markdown → plain text for excerpt fallback.
 */
export function autoExcerpt(body, max = 220) {
  if (!body) return "";
  const html = looksLikeHtml(body) ? String(body) : marked.parse(String(body));
  const text = String(html)
    .replace(/<[^>]+>/g, " ")
    .replace(/&nbsp;/g, " ")
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/\s+/g, " ")
    .trim();
  return text.length > max ? text.slice(0, max - 1) + "…" : text;
}
